import posthog from 'posthog-js';

/**
 * Track custom events in PostHog for analytics.
 * Usage: track('event_clicked', { eventName: 'Marvel Trivia', venueName: 'Palisade Pizza' })
 */
export function track(event: string, properties?: Record<string, unknown>): void {
  posthog.capture(event, properties);
}

// Pre-defined event trackers for common actions
export const analytics = {
  /** User clicked an event card on the schedule */
  eventClicked: (eventName: string, venueName: string) =>
    track('event_clicked', { event_name: eventName, venue_name: venueName }),

  /** User clicked "See Upcoming Events" on the hero */
  heroCtaClicked: (cta: 'upcoming_events' | 'book_private') =>
    track('hero_cta_clicked', { cta }),

  /** User submitted the contact/booking form */
  contactFormSubmitted: (eventType: string) =>
    track('contact_form_submitted', { event_type: eventType }),

  /** User subscribed to newsletter */
  newsletterSubscribed: () =>
    track('newsletter_subscribed'),

  /** User clicked a venue link (external) */
  venueVisited: (venueName: string) =>
    track('venue_link_clicked', { venue_name: venueName }),

  /** User opened the gallery lightbox */
  galleryImageViewed: (imageIndex: number) =>
    track('gallery_image_viewed', { image_index: imageIndex }),
};
